import { provideZoneChangeDetection } from "@angular/core";
/**
 * @license
 * Copyright (c) 2026 STACK SOFTWARE. All Rights Reserved.
 * Proprietary and confidential. See LICENSE in the project root.
 */
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { provideGlobalGridOptions } from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager, ModuleRegistry } from 'ag-grid-enterprise';

import { AgChartsCommunityModule } from 'ag-charts-community';

import { AppModule } from './app/app.module';


ModuleRegistry.registerModules([AllEnterpriseModule.with(AgChartsCommunityModule)]);

// AG Grid v33+ defaults to the Theming API. We still ship the legacy CSS themes
// (ag-grid.css + ag-theme-balham/material) via styles.scss, so opt every grid
// into the legacy theme globally to keep the existing look and avoid the
// "mixing legacy and Theming API" runtime error.
provideGlobalGridOptions({ theme: 'legacy' });


LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-095376}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Stack_Software}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Stack}_only_for_{2}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Stack}_need_to_be_licensed___{Stack}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{6_June_2027}____[v3]_[01]_MTgxMjIzNjQwMDAwMA==ff6f23b19fc5b8f92f2b6442c2e2278e',
);

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch((err) => console.error(err));
